/* @jsxImportSource react */

import { type PropsWithChildren } from 'react';
import { CarouselVirtualizedList } from './CarouselVirtualizedList.client';
import { CarouselProvider } from './CarouselProvider';
import { CarouselWrapper } from './CarouselWrapper.client';
import { CarouselNav } from './CarouselNav.client';

export const Carousel = ({
  children,
  style,
  className,
}: PropsWithChildren<{ style?: React.CSSProperties; className?: string }>) => (
  <CarouselProvider>
    <CarouselWrapper style={style} className={className}>
      <CarouselNav />
      <CarouselVirtualizedList>{children}</CarouselVirtualizedList>
    </CarouselWrapper>
  </CarouselProvider>
);
